import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectExternalCost } from "../Model/ProposalProjectExternalCost";

export async function getProposalProjectExternalCost(idProposalProject) {
	let response = await getAPIResponse("/v1/proposal-project-external-cost/"+idProposalProject);
	if (response === null) {
		return null;
	}
	let proposalProjectExternalCost = response.map(data => ProposalProjectExternalCost.createFromResponseData(data));
	return proposalProjectExternalCost;
}
